<div class="login-container">
  <div class="login-brand">
    <div class="brand-decoration"></div>
    <div class="brand-content">
      <span class="brand-eyebrow">Nyzed</span>
      <h1 class="brand-title">Conferma<br /><em>il tuo account</em></h1>
      <p class="brand-tagline">{{ "confirm_email.tagline" | translate }}</p>
    </div>
  </div>

  <div class="login-form-side">
    <div class="login-card">

      <ng-container *ngIf="loading">
        <h2>{{ "confirm_email.confirming_title" | translate }}</h2>
        <p>{{ "confirm_email.confirming_text" | translate }}</p>
      </ng-container>

      <ng-container *ngIf="!loading && done">
        <div class="success-box">
          <span class="success-icon">✦</span>
          <h2>{{ "confirm_email.success_title" | translate }}</h2>
          <p>{{ "confirm_email.success_text" | translate }}</p>
        </div>
      </ng-container>

      <ng-container *ngIf="!loading && !done && showResendForm">
        <h2>{{ "confirm_email.invalid_title" | translate }}</h2>
        <div class="error-msg" *ngIf="error">{{ error }}</div>

        <ng-container *ngIf="!resendSent; else resendSentState">
          <p>{{ "confirm_email.resend_intro" | translate }}</p>
          <div class="input-group">
            <input
              class="input-field"
              type="email"
              [placeholder]="'confirm_email.resend_placeholder' | translate"
              [(ngModel)]="resendEmail"
              (keyup.enter)="resend()"
              autocomplete="email"
              autocapitalize="off"
            />
          </div>
          <button class="submit-button" (click)="resend()" [disabled]="resendLoading">
            {{ resendLoading ? ("confirm_email.resend_loading" | translate) : ("confirm_email.resend_btn" | translate) }}
          </button>
        </ng-container>

        <ng-template #resendSentState>
          <div class="success-box">
            <span class="success-icon">✦</span>
            <p>{{ "confirm_email.resend_sent" | translate }}</p>
          </div>
        </ng-template>
      </ng-container>

      <p class="register-link" style="margin-top:1.5rem">
        <a routerLink="/login">{{ "confirm_email.back_to_login" | translate }}</a>
      </p>
    </div>
  </div>
</div>
